import React, { useState, useEffect, useRef } from 'react';
import style from './BodyMassWrite.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import Modal from '../../../../../components/comm/Modal';
import CustomDatePicker from '../../../../../components/datepicker/CustomDatePicker';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import URL from "../../../../../constants/url";
import ToastPopup from '../../../../../components/comm/ToastPopup';
import { calculateBMI } from '../../../../../assets/js/comm';
import { useNavigate, useLocation } from "react-router-dom";

import dayjs from 'dayjs';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';


const BodyMassWrite = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [recordDate, setRecordDate] = useState('');
    const [openRecordDate, setOpenRecordDate] = useState(false);
    const [recordTime, setRecordTime] = useState('');
    const [openRecordTime, setOpenRecordTime] = useState(false);
    const [time, setTime] = useState({ hour: "", minute: "" });
    const pointInputRef = useRef(null);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [stature, setStature] = useState('');  //키
    const [weight, setWeight] = useState(''); // 체중

    //전송중 체크
    const isSendingRef = useRef(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);  //모달창
    const [modalTimeOpen, setModalTimeOpen] = useState(false);  //모달창

    // focus ref 추가
    const focusDateInputRef = useRef(null);
    const focusTimeInputRef = useRef(null);

    const [dateInputFocused, setDateInputFocused] = useState(false);
    const [timeInputFocused, setTimeInputFocused] = useState(false);

    const [latestRecord, setLatestRecord] = useState(null); // DB에서 불러온 최신 기록
    const statureRef = useRef(null);
    const weightRef = useRef(null);

    const dayRef = useRef(null);
    const timeRef = useRef(null);



    const handleDateConfirm = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const picked = new Date(date);
        picked.setHours(0, 0, 0, 0);

        if (picked > today) {
            setOpenRecordDate(false); // 선택 후 바텀시트 닫기
            setModalOpen(true);   // 미래 날짜 선택 시 모달 열기
            setDateInputFocused(true);
            setOpenRecordDate(false);
            return;
        }

        setRecordDate(picked);
        setOpenRecordDate(false); // 선택 후 바텀시트 닫기
        setDateInputFocused(false);  // 올바른 날짜 선택 시 클래스 제거

        setTimeout(() => {
            if (dayRef.current) {
                dayRef.current.focus({ preventScroll: true });
                dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
    };


    const closeModal = () => {
        setModalOpen(false);

        // 포커스 이동만 처리
        setTimeout(() => {
            focusDateInputRef.current?.focus({ preventScroll: true });
            focusDateInputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);
        setOpenRecordDate(true);
        setDateInputFocused(true);  //클래스 추가
    }

    const closeModalTime = () => {
        setModalTimeOpen(false);

        setTimeout(() => {
            focusTimeInputRef.current?.focus({ preventScroll: true });
            focusTimeInputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);

        setOpenRecordTime(true);
        setTimeInputFocused(true); //클래스 추가
    }




    //시간표현 설정     
    const handleConfirmTime = (value) => {

        const now = new Date();
        const selectedDateTime = new Date(recordDate || now); // 선택된 날짜가 없으면 오늘 기준

        const hour = parseInt(value.hour, 10);
        const minute = parseInt(value.minute, 10);
        selectedDateTime.setHours(hour, minute, 0, 0);

        if (selectedDateTime > now) {
            setOpenRecordTime(false);   // 미래 시간 선택 시 모달 열기
            setModalTimeOpen(true);
            return;
        }

        setTime(value);

        const period = hour < 12 ? '오전' : '오후';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        const formattedTime = `${period} ${hour12}:${minute.toString().padStart(2, '0')}`;

        setRecordTime(formattedTime);
        setOpenRecordTime(false);
        setTimeInputFocused(false);

        setTimeout(() => {
            if (timeRef.current) {
                timeRef.current.focus({ preventScroll: true });
                timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 200);
       
    };


    useEffect(() => {

        // 현재 시간 기준 기본값 설정
        const now = new Date();
        setRecordDate(now);  // 측정일자

        const hour = now.getHours();
        const minute = now.getMinutes();

        setTime({ hour: hour.toString().padStart(2, '0'), minute: minute.toString().padStart(2, '0') });

        const period = hour < 12 ? '오전' : '오후';
        const hour12 = hour % 12 === 0 ? 12 : hour % 12;
        const formattedTime = `${period} ${hour12}:${minute.toString().padStart(2, '0')}`;

        setRecordTime(formattedTime);  // 측정시간
    }, []);


    const handleComplete = async () => {
        if (!stature) {
            setToastMessage('키를 입력해주세요.');
            setToast(true);
            return;
        }
        else if (stature < 0) {
            setToastMessage('0cm 이상의 키를 입력해주세요.');
            setToast(true);
            return;
        }

        if (!weight) {
            setToastMessage('체중을 입력해주세요.');
            setToast(true);
            return;
        }
        else if (weight < 0) {
            setToastMessage('0kg 이상의 체중을 입력해주세요.');
            setToast(true);
            return;
        }

        if (!recordDate) {
            setToastMessage('날짜을 선택해주세요.');
            setToast(true);
            return;
        }

        if (!recordTime) {
            setToastMessage('시간을 선택해주세요.');
            setToast(true);
            return;
        }
        if (isSendingRef.current) return;
        isSendingRef.current = true;

        // '오전 10:30' → '10:30' (24시간제)
        const convertTo24Hour = (timeStr) => {
            const [period, time] = timeStr.split(' ');
            let [hour, minute] = time.split(':').map(Number);
            if (period === '오후' && hour !== 12) hour += 12;
            if (period === '오전' && hour === 12) hour = 0;
            return `${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}`;
        };

        const recDe = dayjs(recordDate).format('YYYYMMDD'); // 예: 20250703
        const recTm = convertTo24Hour(recordTime) + "00"; // 예: 1430 -> 143000
        const bmi = calculateBMI(Number(stature), Number(weight)).result.bmi;

        const getRsltCd = (bmi) => { // 결과코드 임의 저장 (추후 기획에 따라 기준 및 코드명 변경 요망)
            if (bmi >= 25.0) {
                return "D"; // Danger
            } else if (bmi >= 23.0 || bmi < 18.5) {
                return "C"; // Caution
            }
            else {
                return "N"; // Normal
            }
        }


        const url = "/homecare/bmi/saveBodyMassRecordHistory"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem('jToken');
        console.log("========> usrInfoId: ", loginUser.usrInfoId);

        const reqBody = {
            usrInfoId: loginUser.usrInfoId
            , recDe: recDe
            , recTm: recTm
            , bmi: bmi
            , height: Number(stature)
            , bdwgh: Number(weight)
            , rsltCd: getRsltCd(bmi)
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                navigate(URL.BODY_MASS_RECORD, { state: { showToast: true, toastMessage: '기록 완료!' } });
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("혈압 측정 기록 저장 중 오류: ", err);
        } finally {
            isSendingRef.current = false;
        }

    };

    // DB에서 최신 기록 불러오기
    useEffect(() => {
        const fetchLatestRecord = async () => {
            const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
            const jToken = localStorage.getItem('jToken');

            try {
                const res = await axiosApi.post("/homecare/bmi/retrieveBodyMassRecordHistory",
                    { usrInfoId: loginUser.usrInfoId },
                    { headers: { Authorization: jToken } }
                );

                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    const recList = res.data.result.recList;

                    if (recList && recList.length > 0) {
                        // height가 있는 마지막 데이터 찾기
                        const lastHeightRecord = [...recList].reverse().find(r => r.height);

                        if (lastHeightRecord) {
                            setStature(lastHeightRecord.height.toString());
                            setLatestRecord(lastHeightRecord); // 재진입 플래그
                        } else {
                            setLatestRecord(null); // 키 값 없음 → 첫 진입
                        }
                    } else {
                        setLatestRecord(null); // 기록 없음 → 첫 진입
                    }
                }
            } catch (err) {
                console.error("체질량 기록 조회 중 오류:", err);
            }
        };

        fetchLatestRecord();
    }, []);


    useEffect(() => {
        if (latestRecord) {
            // 마지막 키 값 존재 → 체중 input 포커스
            setTimeout(() => {
                weightRef.current?.focus();
                weightRef.current.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' ,
                    });
            }, 300);
        } else {
            // 키 값 없음 → 첫 진입 → 키 input 포커스
            setTimeout(() => {
                statureRef.current?.focus();
                statureRef.current.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'center' ,
                    });
            }, 300);
        }
    }, [latestRecord]);




    return (
        <>

            <HeadSub title="체질량 기록하기" />


            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['record-writebox']}>
                        <div className={style['date-record']}>
                            <p>측정 일자</p>
                            <div className='input-box' data-type='c' ref={dayRef} tabIndex={0} >
                                <input
                                    type="button"
                                    inputMode="none"
                                    placeholder='25.02.07'
                                    value={recordDate ? dayjs(recordDate).format('YY.MM.DD') : ''}
                                    onClick={() => setOpenRecordDate(true)}
                                    className={dateInputFocused ? 'focused' : ''}
                                    ref={focusDateInputRef}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className={style['time-record']}>
                            <p>측정 시간</p>
                            <div className='input-box' data-type='c' ref={timeRef} tabIndex={0}>
                                <input
                                    type="button"
                                    inputMode="none"
                                    placeholder='오후 01:30'
                                    value={recordTime}
                                    onClick={() => setOpenRecordTime(true)}
                                    className={timeInputFocused ? 'focused' : ''}
                                    ref={focusTimeInputRef}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div>
                            <p>키</p>
                            <div className='input-box' data-type='c'>
                                <input type="number"
                                    placeholder='---'
                                    ref={statureRef}
                                    value={stature}
                                    onChange={(e) => setStature(e.target.value)}
                                    aria-label='키를 입력해주세요'
                                />
                                <span className='unit'>cm</span>
                            </div>
                        </div>
                        <div>
                            <p>체중</p>
                            <div className='input-box' data-type='c'>
                                <input
                                    type="number"
                                    placeholder='---'
                                    ref={weightRef}
                                    value={weight}
                                    onChange={(e) => setWeight(e.target.value)}
                                    aria-label='체중을 입력해주세요'
                                />
                                <span className='unit'>kg</span>
                            </div>
                        </div>


                        <BottomSheet
                            scrollLocking={false}
                            expandOnContentDrag={false}
                            open={openRecordTime}
                            onDismiss={() => {
                                setOpenRecordTime(false);
                                setTimeInputFocused(false); // 취소 시 focused 클래스 제거
                                setTimeout(() => {
                                    if (timeRef.current) {
                                        timeRef.current.focus({ preventScroll: true });
                                        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                            }}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                        >

                            <CustomTimePicker
                                onConfirm={handleConfirmTime}
                                titleTxt="측정 시간 선택"
                                onClose={() => {
                                    setOpenRecordTime(false);
                                    setTimeInputFocused(false); // 취소 버튼 클릭 시 클래스 제거
                                    setTimeout(() => {
                                    if (timeRef.current) {
                                        timeRef.current.focus({ preventScroll: true });
                                        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                                }}
                            />
                        </BottomSheet>

                        <BottomSheet
                            scrollLocking={false}
                            expandOnContentDrag={false}
                            open={openRecordDate}
                            onDismiss={() => {
                                setOpenRecordDate(false);
                                setDateInputFocused(false);

                                 if (dateInputFocused) {
                                       setModalOpen(true);
                                   }

                                setTimeout(() => {
                                    if (dayRef.current) {
                                        dayRef.current.focus({ preventScroll: true });
                                        dayRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                    }
                                }, 200);
                            }}
                            snapPoints={({ minHeight }) => minHeight}
                            blocking={true}
                        >

                            <CustomDatePicker
                                titleTxt="측정 일자 선택"
                                onClose={() => {
                                    setOpenRecordDate(false);
                                    setDateInputFocused(false);
                                }}
                                //onConfirm={(date) => setRecordDate(date)}
                                onConfirm={handleDateConfirm}
                            />
                        </BottomSheet>

                    </div>




                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">

                            <div className='btn-layout' data-btn-num="1">
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={() => handleComplete()}
                                    disabled={!stature || !weight || !recordDate || !recordTime}
                                >
                                    <span>완료</span>
                                </button>
                            </div>

                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}
                    {/* 토스트 */}
                    {toast && (
                        <ToastPopup
                            setToast={setToast}
                            message={toastMessage}
                            opacity="90"
                        />
                    )}

                </div>
            </div>

            <Modal isOpen={modalOpen} setIsOpen={setModalOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>오늘 날짜보다 미래 날짜를 선택할 수 없습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={closeModal}>
                                <span>확인</span>
                            </button>

                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={modalTimeOpen} setIsOpen={setModalTimeOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>현재 시간보다 미래 시간을 선택할 수 없습니다.</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={closeModalTime}>
                                <span>확인</span>
                            </button>

                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default BodyMassWrite;
